import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-warning-button',
  templateUrl: './warning-button.component.html',
  styleUrls: ['./warning-button.component.css']
})
export class WarningButtonComponent {

  @Input() disabled: boolean;
  @Input() text: string;
  @Input() icon: string;
  @Input() buttonText: string;


  constructor() { }

}
